<template>
  <div class="orderStatistics">
      <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="12"><div class="grid-content bg-purple">系统数据统计</div></el-col>
          <el-col :span="12"><div class="grid-content bg-purple-light">
              <el-date-picker v-model="daterange" value-format="timestamp" format="yyyy 年 MM 月 dd 日" unlink-panels
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" @click="handlerDateRangeClick">查询</el-button>
              <el-radio-group v-model="tabPosition" @input="handleTabClick">
                <el-radio-button label="1">本月</el-radio-button>
                <el-radio-button label="2">上月</el-radio-button>
                <el-radio-button label="3">本年</el-radio-button>
              </el-radio-group>
          </div></el-col>
      </el-row>
      <el-row type="flex" :gutter="10" class="row-overview" justify="space-around">
          <el-col :span="12"><div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                  <span>工单数据概览</span>
                </div>
                <div class="mains">
                  <el-row :gutter="20">
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle" title="工单总量（个）">
                        <template slot="formatter">{{ counterData.total }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle" title="已处理（个）">
                        <template slot="formatter">{{ counterData.accepted_total }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle"  :value="counterData.finish_total" title="处理完成（个）">
                        <template slot="formatter">{{ counterData.finish_total }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle"  title="归档率">
                        <template slot="formatter">{{ counterData.pof_rate }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle" title="归档（个）">
                        <template slot="formatter">{{ counterData.pof_total }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                  <el-col :span="7">
                    <div>
                      <el-statistic :value-style="valueStyle" title="超时工单(个)">
                        <template slot="formatter">{{ counterData.timeout_total }} </template>
                      </el-statistic>
                    </div>
                  </el-col>
                </el-row>
                </div>
              </el-card>
          </div></el-col>
          <el-col :span="12"><div class="grid-content bg-purple-light">
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                  <span>响应时间排行</span>
                </div>
                <div class="table" style="height: 200px;">
                  <el-table
                    border
                    max-height="200px"
                    :data="responTableData"
                    style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="姓名"
                      >
                    </el-table-column>
                    <el-table-column
                      prop="accepted_total"
                      label="累计受理工单"
                      >
                    </el-table-column>
                    <el-table-column
                      prop="accept_time_use"
                      label="平均响应时间">
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
          </div></el-col>
      </el-row>
      <!-- 饼状图 -->
      <el-row :gutter="10" class="echart_pie">
        <el-col :span="12">
          <el-card class="pieCard" shadow="hover">
            <div slot="header" class="clearfix">
                  <span>类型分布情况</span>
            </div>
            <div class="pieMain">
              <div id="pieChartStatus"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="pieCard" shadow="hover">
            <div slot="header" class="clearfix">
                  <span>产品分布情况</span>
            </div>
            <div class="pieMain">
              <div id="pieChartPart"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      
      <el-row class="echart_Line">
        <el-card shadow="hover">
          <div class="lineMain">
            <div id="lineChart"></div>
          </div>
        </el-card>
      </el-row>

      <el-row class="departOrderStatic">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>各部门工单完成情况</span>
          </div>
          <el-col :span="24">
            <el-table
              border
              max-height="400px"
              :data="cateTableData"
              style="width: 100%">
              <el-table-column
                prop="cate_name"
                label="部门"
                >
              </el-table-column>
              <el-table-column
                prop="total"
                label="全部工单"
                >
              </el-table-column>
              <el-table-column
                prop="total"
                label="工单数"
                >
              </el-table-column>
              <el-table-column
                prop="not_response_total"
                label="未响应"
                >
              </el-table-column>
              <el-table-column
                prop="accepted_total"
                label="进行中的">
              </el-table-column>
              <el-table-column
                prop="finish_total"
                label="已完成">
              </el-table-column>
              <el-table-column
                prop="changeback_total"
                label="已退回">
              </el-table-column>
              <el-table-column
                prop="close_total"
                label="待归档">
              </el-table-column>
              <el-table-column
                prop="avg_response_time"
                label="平均响应时间">
              </el-table-column>
              <el-table-column
                prop="response_timeout_rate"
                label="响应超时率">
              </el-table-column>
              <el-table-column
                prop="pof_total"
                label="归档">
              </el-table-column>
              <el-table-column
                prop="pof_rate"
                label="归档率">
              </el-table-column>
              <el-table-column
                prop="not_pof_total"
                label="未归档">
              </el-table-column>
            </el-table>
          </el-col>
        </el-card>
      </el-row>

      <el-row class="personOrderStatic">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>人员工单完成情况</span>
          </div>
          <el-col :span="24">
            <el-table
              border
              max-height="400px"
              :data="personFinishData"
              style="width: 100%">
              <el-table-column
                prop="worker_name"
                label="负责人"
                >
              </el-table-column>
              <el-table-column
                prop="total"
                label="工单数"
                >
              </el-table-column>
              <el-table-column
                prop="accepted_total"
                label="进行中的">
              </el-table-column>
              <el-table-column
                prop="finish_total"
                label="已完成">
              </el-table-column>
              <el-table-column
                prop="avg_response_time"
                label="平均响应时间">
              </el-table-column>
              <el-table-column
                prop="response_timeout_rate"
                label="响应超时率">
              </el-table-column>
              <el-table-column
                prop="pof_total"
                label="归档">
              </el-table-column>
              <el-table-column
                prop="pof_rate"
                label="归档率">
              </el-table-column>
            </el-table>
          </el-col>
        </el-card>
      </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { counterData,counterInsert,counterFinishWorker,counterDistributionType,counterFinishCate,counterDistributionCate,counterResponseTime } from '../../utils/api'
export default {
components: {},
props: {},
data() {
  return {
      daterange:'',
      time_area:1,
      counterData:{
        total:'',
        accepted_total:'',
        finish_total:'',
        pof_total:'',
        pof_rate:'',
        timeout_total:''
      },
      tabPosition:'1',
      title:'工单总量（个）',
      valueStyle:{
          'font-size':'1.5vw',
          'color':'#666666',
          'margin-top':'10px'
      },
      responTableData: [],
      counterTypeData:{},
      nowData:[],
      lastData:[],
      xAxisData:[],
      personFinishData:[],
      cateTableData:[],
      partData:[]
      
  };
},
watch: {},
computed: {},
methods: {
  handlerDateRangeClick(value){
      console.log(this.daterange);
      this.time_area = this.daterange.join(',');
      this.initEvent()
  },
  handleTabClick(value){
      console.log(value,'点击了');
      this.time_area = value
      this.initEvent()
  },
  //初始化状态的饼状图
  initPieChartStatus(){
    var that = this
    console.log(that.counterTypeData,'counterTypeData');
    var statusChart = echarts.init(document.getElementById('pieChartStatus'))
    statusChart.setOption({
      series: [
        {
          type: 'pie',
          data:that.counterTypeData
        }
      ]
    })
    window.onresize = function(){
      statusChart.resize()
    }
  },
  //各部门的饼状图
  initPieChartPart(){
    var partChart = echarts.init(document.getElementById('pieChartPart'))
    partChart.setOption({
      series: [
        {
          type: 'pie',
          data: this.partData
        }
      ]
    })
    window.onresize = function(){
      partChart.resize()
    }
  },
  //初始化折现图
  initLineCHart(){
    var lineChart = echarts.init(document.getElementById('lineChart'));
    lineChart.setOption({
      title: {
        text: '系统工单同比提交情况'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['本日/月/年', '昨日/月/年']
      },
      xAxis: {
      data: this.xAxisData
      },
      yAxis: {},
      series: [
        {
          name:'本日/月/年',
          data: this.nowData,
          type: 'line',
        },
        {
          name:'昨日/月/年',
          data: this.lastData,
          type: 'line',
        }
      ]
    })
    window.onresize = function(){
      lineChart.resize()
    }
  },
  //工单数据概览
  getCounterData(){
    var params = {
      time_area:this.time_area
    }
    counterData(params)
    .then(res=>{
      console.log(res,'统计数据');
      if(res.message.status == 'success'){
        this.counterData = res.data
      }else{
        console.log(res.message.text);
        this.$message.error(res.message.text)
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //响应时间排行
  getCounterResponseTime(){
    var params = {
      time_area:this.time_area
    }
    counterResponseTime(params)
    .then(res=>{
      console.log(res,'响应时间排行');
      if(res.message.status == 'success'){
        this.responTableData = res.data
        this.responTableData.forEach(item=>{
          item.name = item.name.split('/')[item.name.split('/').length-1]
        })
      }else{
        this.responTableData = []
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //工单分布情况（按工单类型）
  getCounterDistributionType(){
    var params = {
      time_area:this.time_area
    }
    counterDistributionType(params)
    .then(res=>{
      console.log(res,'工单分布情况（按工单类型）');
      if(res.message.status == 'success'){
        this.counterTypeData = res.data
        this.counterTypeData.forEach(item=>{
          item['value'] = item.order_total
        })
        this.initPieChartStatus()
      }else{
        this.counterTypeData = []
        this.initPieChartStatus()
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //工单分布情况（按产品分类）
  getCounterDistributionCate(){
    var params = {
      time_area:this.time_area
    }
    counterDistributionCate(params)
    .then(res=>{
      console.log(res,'工单分布情况统计（按产品分类）');
      if(res.message.status == 'success'){
        this.partData = res.data
        this.partData.forEach(item=>{
          item['value'] = item.order_total
        })
        this.initPieChartPart()
      }else{
        this.partData = []
        this.initPieChartPart()
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //工单提交情况
  getCounterInsert(){
    var params = {
      time_area:this.time_area
    }
    counterInsert(params)
    .then(res=>{
      console.log(res,'工单提交情况');
      if(res.message.status == 'success'){
        this.nowData = []
        this.lastData = []
        this.xAxisData = []
        for(let i in res.data.result.now){
          this.nowData.push(res.data.result.now[i])
          this.lastData.push(res.data.result.last[i])
          this.xAxisData.push(i)
        }
        this.initLineCHart()
      }else{
        this.nowData = []
        this.lastData = []
        this.xAxisData = []
        this.initLineCHart()
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //工单完成情况（按员工）
  getCounterFinishWorker(){
    var params = {
      time_area:this.time_area
    }
    counterFinishWorker(params)
    .then(res=>{
      console.log(res,'工单完成情况（按员工）');
      if(res.message.status == 'success'){
        this.personFinishData = res.data
        this.personFinishData.forEach(item=>{
          item.worker_name = item.worker_name.split('/')[item.worker_name.split('/').length-1]
        })
      }else{
        this.personFinishData = []
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  //工单完成情况（按产品分类）
  getCounterFinishCate(){
    var params = {
      time_area:this.time_area
    }
    counterFinishCate(params)
    .then(res=>{
      console.log(res,'工单完成情况（按产品分类）');
      if(res.message.status == 'success'){
        this.cateTableData = res.data
      }else{
        this.cateTableData = []
      }
    })
    .catch(err=>{
      console.log(err);
    })
  },
  initEvent(){
    this.getCounterData()
    this.getCounterResponseTime()
    this.getCounterDistributionType()
    this.getCounterDistributionCate()
    this.getCounterInsert()
    this.getCounterFinishWorker()
    this.getCounterFinishCate()
  }
},
created() {},
mounted() {
},
activated(){
  this.initEvent()
}
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
:deep(.el-card__header){
  padding: 4px 12px;
  font-size: 14px;
}
:deep(.el-card__body, .el-main){
      padding: 10px;
  }


:deep(.row-bg) {
  background-color: #f5f5f5;
  .grid-content {
  border-radius: 4px;
  min-height: 50px;
  display: flex;
  align-items: center;
}
.bg-purple {
  font-size: 16px;
  padding-left: 10px;
}
.bg-purple-light {
  .el-card__body{
      height: 200px;
  }
}

}

:deep(.row-overview) {
  .grid-content {
  border-radius: 4px;
  min-height: 50px;
  .el-statistic .head{
      font-size: 14px;
      color: #999;
  }
}
.bg-purple {
  // font-size: 14px;
  .mains{
      height: 200px;
      .el-row{
         padding: 10px;
         display: flex;
         justify-content: center;
         align-items: center;
      }
  }
}
.bg-purple-light{
  background: blue;
  .el-table .cell{
      line-height: 12px;
  }
}

}

.echart_pie{
  width: 100%;
  .pieCard{
    width: 100%;
    .pieMain{
      div{
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: center;
      }
    }
  }
}

.echart_Line{
  width: 100%;
  .lineMain{
    width: 100%;
    div{
      width: 100%;
      height: 300px;
    }
  }
}
</style>